import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { Base } from "../../framework/base";
import * as store from "../../framework/customStore";
import * as storeActions from "../../models/store/storeActions";
import { t } from "i18next";

interface ConfirmationDialogProps {
    show: boolean;
    title: string;
    onYes: () => void | Promise<void>;
    onCancel?: () => void;
    yesTitle?: string;
    noTitle?: string;
    yesClasses?: string;
    noClasses?: string;
    text?: string;
    content?: React.ReactNode;
    onNo?: () => void;
}

export const ConfirmationDialog = (props: ConfirmationDialogProps) => {
    const { show, title, onYes, onCancel, yesTitle, noTitle, yesClasses, noClasses, text, content, onNo } = props;
    const withClearConfirmation = (callback: () => void) => {
        store.customStore.dispatch(storeActions.clearConfirmation());
        if (callback) {
            callback();
        }
    };

    return (
        <Dialog
            open={show}
            onBackdropClick={() => withClearConfirmation(onCancel)}
        >
            <DialogTitle variant="h3" marginBottom={0}>
                {title}
            </DialogTitle>
            {content &&
                <DialogContent>
                    {content}
                </DialogContent>
            }
            {text &&
                <DialogContent>
                    {!Base.isFormattedText(text)
                        ? text
                        : <div dangerouslySetInnerHTML={{ __html: Base.getFormattedText(text) }}/>
                    }
                </DialogContent>
            }
            <DialogActions>
                <Button variant="contained" autoFocus onClick={() => withClearConfirmation(onCancel)}>{t("common.cancel")}</Button>
                {onNo &&
                    <Button variant="contained" onClick={() => withClearConfirmation(onNo)} classes={noClasses}>{noTitle ?? t("common.no")}</Button>
                }
                <Button onClick={() => withClearConfirmation(onYes)} variant="primary" className={yesClasses}>{yesTitle ?? t("common.ok")}</Button>
            </DialogActions>
        </Dialog>
    );
};
